import { createTheme } from "@mui/material/styles";
import { Colors, ColorMappings } from "../constants/colors";
import muiIcons from "./muiIcons";
import muiSvgIcons from "./muiSvgIcons";
import muiPaper from "./muiPaper";
import muiAppBar from "./muiAppBar";
import muiToolbar from "./muiToolbar";
import { muiTabs } from "./muiTabs";
import muiIconButton from "./muiIconButton";
import muiButton from "./muiButton";
import muiAlert from "./muiAlert";
import muiLink from "./muiLink";
import muiChip from "./muiChip";
import muiSwitch from "./muiSwitch";
import muiTooltip from "./muiTooltip";
import muiDivider from "./muiDivider";
import muiAccordionSummary from "./muiAccordionSummary";
import muiToggleButton from "./muiToggleButton";
import muiDialog from "./muiDialog";

import {
  heroStyles,
  htmlStyles,
  academyStyles,
  courseStyles,
  detailsStyles,
  textStyles,
} from "./styles";
import sfHaloIcon from "./sfHaloIcon";

const getTransColorsObj = () => {
  let obj = {};
  Object.keys(Colors).forEach((key) => {
    let backgroundColor = Colors[key];
    obj[key.toLocaleLowerCase()] = {
      main: backgroundColor,
      contrastText:
        ColorMappings.find((x) => x.backgroundColor == backgroundColor)
          ?.fontColor ?? Colors.WHITE,
    };
  });
  return obj;
};

let theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
      xxl: 1920,
    },
  },
  //this changes the z-index of the snackbar(notifications popups)
  zIndex: {
    snackbar: 99999,
  },
  typography: {
    fontFamily: [
      "ey_interstate",
      "noto_sans",
      "Helvetica Neue",
      "Arial",
      "sans-serif",
    ].join(","),
    fontSize: 12,
    ...heroStyles,
    ...htmlStyles,
    ...academyStyles,
    ...courseStyles,
    ...detailsStyles,
    ...textStyles,
  },
  shape: {
    borderRadius: 2,
  },
  palette: {
    type: "dark",
    contrastThreshold: 4.5,
    primary: {
      main: Colors.GREY200,
      contrastText: Colors.GREY500,
    },
    secondary: {
      main: Colors.YELLOW400,
    },
    ...getTransColorsObj(),
  },
  components: {
    // MuiCssBaseline: {
    //   styleOverrides: `
    //     body {
    //       background: linear-gradient(108.45deg, rgba(121, 116, 128, 0) 12.64%, rgba(116, 116, 128, 0.252) 30.32%, rgba(116, 116, 128, 0.145208) 48.33%, rgba(116, 116, 128, 0.252) 66.02%, rgba(116, 116, 128, 0) 83.69%);
    //       background-size: 200% 200%;
    //       animation: gradient-animation 5s ease infinite;
    //       background-color: #1A1B24;
    //       height: 100vh;
    //     }
    //   `,
    // },
    MuiPaper: muiPaper,
    MuiAppBar: muiAppBar,
    MuiToolbar: muiToolbar,
    MuiTabs: muiTabs,
    //MuiTab: muiTab,
    MuiIconButton: muiIconButton,
    MuiButton: muiButton,
    MuiIcon: muiIcons,
    MuiSvgIcon: muiSvgIcons,
    MuiAlert: muiAlert,
    MuiLink: muiLink,
    MuiChip: muiChip,
    MuiSwitch: muiSwitch,
    MuiTooltip: muiTooltip,
    haloIcon: sfHaloIcon,
    MuiDivider: muiDivider,
    MuiAccordionSummary: muiAccordionSummary,
    MuiToggleButton: muiToggleButton,
    MuiDialog: muiDialog,
  },
  scrollable: {
    overflowY: "auto",
    "&::-webkit-scrollbar-thumb,::-webkit-scrollbar-track": {
      visibility: "hidden",
    },
    "&:hover": {
      "&::-webkit-scrollbar-thumb,::-webkit-scrollbar-track": {
        visibility: "visible",
      },
    },
  },
});

//theme = responsiveFontSizes(theme);

export default theme;
